import initSlickWithArrowEvent from "../components/slick-utils";

function initMaierMediaDisplayBlockSlider(slider) {
    const slick = initSlickWithArrowEvent(
        $(slider),
        {
            arrows: true,
            dots: true,
            prevArrow: '<span class="slide-arrow slide-arrow-white prev">Prev</span>',
            nextArrow: '<span class="slide-arrow slide-arrow-white next">Next</span>',
            autoplay: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1
        }
    );
}

function observeMaierMediaDisplayBlockSlider() {
    // IntersectionObserver
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                initMaierMediaDisplayBlockSlider(entry.target);
                intersectionObserver.unobserve(entry.target);
            }
        });
    }, {rootMargin: '200px 0px'});

    document.querySelectorAll('.maier-media-display-block.hide-desktop .maier-media-display-block-list').forEach(slider => intersectionObserver.observe(slider));

    // MutationObserver
    const mutationObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length >= 1) {
                for (var i = 0; i < mutation.addedNodes.length; i++) {
                    if (undefined !== mutation.addedNodes[i].localName) {
                        mutation.addedNodes[i].querySelectorAll('.maier-media-display-block.hide-desktop .maier-media-display-block-list').forEach(slider => initMaierMediaDisplayBlockSlider(slider));
                    }
                }
                ;
            }
        });
    });

    mutationObserver.observe(document.body, { attributes: false, childList: true, characterData: false, subtree: true });
}

function setupMaierMediaDisplayBlockSlider() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            observeMaierMediaDisplayBlockSlider();
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupMaierMediaDisplayBlockSlider);
} else {
    setupMaierMediaDisplayBlockSlider();
}